import { useState } from 'react';
import { useData } from '@yingbaba/api';
import type { Page, Project } from '@yingbaba/types';
import { Button, Field, Pagination, QueryState, Select } from '@yingbaba/ui';

export function DigitalPurchaseProject({
  onSelect,
}: {
  onSelect: (project: Project | null) => void;
}) {
  const [enabled, setEnabled] = useState(false),
    [selected, setSelected] = useState<Project | null>(null);
  const [query, setQuery] = useState(''),
    [search, setSearch] = useState(''),
    [page, setPage] = useState(1);
  const projects = useData<Page<Project>>(
    `/digital/project-candidates?q=${encodeURIComponent(search)}&page=${page}`,
    enabled,
  );
  const options = (projects.data?.items || []).map((p) => ({ value: p.id, label: p.title }));
  if (selected && !options.some((p) => p.value === selected.id))
    options.unshift({ value: selected.id, label: selected.title });
  return (
    <div className="digital-project-picker">
      <label className="project-tool-consent">
        <input
          type="checkbox"
          checked={enabled}
          onChange={(e) => {
            setEnabled(e.target.checked);
            setSelected(null);
            onSelect(null);
          }}
        />
        选择工作台中的已有项目
      </label>
      {enabled && (
        <>
          <div className="project-file-search">
            <input
              className="input"
              aria-label="查找授权项目"
              placeholder="搜索项目名称"
              value={query}
              maxLength={200}
              onChange={(e) => setQuery(e.target.value)}
            />
            <Button
              variant="secondary"
              type="button"
              onClick={() => {
                setSearch(query.trim());
                setPage(1);
              }}
            >
              查找
            </Button>
          </div>
          <QueryState query={projects}>
            <Field label="关联已有项目">
              <Select
                aria-label="选择授权项目"
                value={selected?.id || ''}
                onChange={(id) => {
                  const p = projects.data?.items.find((p) => p.id === id) || null;
                  setSelected(p);
                  onSelect(p);
                }}
                options={[{ value: '', label: '请选择项目' }, ...options]}
              />
            </Field>
            {!projects.data?.items.length && (
              <p className="muted small">没有匹配的进行中项目。可取消勾选，先填写具名项目名称。</p>
            )}
          </QueryState>
          <Pagination page={page} size={24} total={projects.data?.total || 0} onPage={setPage} />
          <p className="muted small">
            购买后，前往该项目的素材页添加授权素材；添加前可确认协作者的访问范围。
          </p>
        </>
      )}
    </div>
  );
}
